import { LastMile } from '../app-bar-menus/assets';
import SolutionsMenuAppBar from '../app-bar-menus';

const prices = {
    title: "pricesMenu.title",
    list: [
        {
            title: "pricesMenu.mapitShip",
            description: "solutionsMenu.mapitShip.subtitle",
            image: LastMile,
            href: '/pricing/mapit-ship'
        },
        {
            title: "pricesMenu.lastMile",
            description: "solutionsMenu.lastMile.subtitle",
            image: LastMile,
            href: '/pricing/mapit-dms'
        },
    ],
    learnMore: "pricesMenu.learnMore"
}


const PricesMenu = () => {

    return (
        <SolutionsMenuAppBar solutions={prices} />
    );
}

export default PricesMenu;
